import { render, staticRenderFns } from "./RegistryWizardFirstStep.vue?vue&type=template&id=b6f0e11c&scoped=true&"
import script from "./RegistryWizardFirstStep.vue?vue&type=script&lang=js&"
export * from "./RegistryWizardFirstStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f0e11c",
  null
  
)

export default component.exports